import { FilterTabEnum, getRetainedAsset, holdingAssetTabs, reportsTabAndDropDownData, switchTabBasedOnDashboardRowClick, tabWithAssetCategory, } from "@frameworks/web/components/Reports/CommonComponent/constant";
import React, { useEffect, useState } from "react";
import HoldingReport from "./HoldingReport";
import di from "../../di/servicelocator";
import { createSearchParams, useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Tab, Tabs } from "react-bootstrap";
import DeviceContext from "@frameworks/web/utils/indentifyDevice";
import _ from "underscore";
import familyDi from "@frameworks/web/components/Reports/FamilyTagging/di/servicelocator";
import FamilyTaggingMain from "@frameworks/web/components/Reports/FamilyTagging/FamilyTaggingReport/FamilyTaggingMain";
import InsuranceReportBanner from "@frameworks/web/components/Reports/HoldingReports/InsuranceInHoldings/InsuranceReportBanner";
import ReportsShimmer from "@frameworks/web/components/Reports/CommonComponent/ReportsShimmer";
import PopBodProcessBlock from "@frameworks/web/components/Reports/RebrandedReports/GenericComponents/PopBodProcessBlock";
const HoldingReportComponent = (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const locationState = location.state;
    const [scrollPosition, setScrollPosition] = React.useState(0);
    const [insuranceTabClass, setInsuranceTabClass] = React.useState("insurance-tab");
    const [isInsuranceVisited, setIsInsuranceVisited] = useState(false);
    /**************************** redux states***************************** */
    const { selectedMember, familyDetails: { myAccCode }, } = useSelector((state) => state.FamilyTagging.familyDetails.reducersData);
    const assetFilter = useSelector((state) => state.holdingReport.data.FilterData);
    const activeHoldingTabName = useSelector((state) => { var _a; return (_a = state.holdingReport) === null || _a === void 0 ? void 0 : _a.activeAssetTab; });
    const { HoldingDataFlags: HoldingDataFlags } = useSelector((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.holdingReport) === null || _a === void 0 ? void 0 : _a.data; });
    const holdingLoader = useSelector((state) => state === null || state === void 0 ? void 0 : state.holdingReport.loader);
    const HoldingData = useSelector((state) => { var _a; return (_a = state.holdingReport) === null || _a === void 0 ? void 0 : _a.data; });
    /******************* functions********************* */
    const handleScroll = () => {
        const position = window.pageYOffset;
        setScrollPosition(position);
    };
    const onTabchange = (akey) => {
        var _a;
        di.holdingReport.saveProdAssetDropDown((_a = reportsTabAndDropDownData[akey].assetProductList) === null || _a === void 0 ? void 0 : _a[0], akey);
        let selectedAssetCategories = tabWithAssetCategory[akey];
        //if there is asset selected when user is in All tab then apply those asset first
        let retainedAssets = getRetainedAsset(akey);
        if (retainedAssets.length > 0)
            selectedAssetCategories = retainedAssets;
        di.holdingReport.onAssetChange(selectedAssetCategories);
        if (akey !== FilterTabEnum.INSURANCE)
            setInsuranceTabClass("insurance-tab");
        else {
            setInsuranceTabClass("");
            setIsInsuranceVisited(true);
            di.holdingReport.toggleQtyBreakDown(false); // qty brake downs
        }
        navigate({
            pathname: "",
            search: createSearchParams({
                reportName: "Holding",
                // tab: akey,
            }).toString(),
        });
    };
    /***********************Hooks************************ */
    useEffect(() => {
        var _a;
        // when user redirect on this page  from  dashboard and refresh
        let assetCategory = null;
        if (locationState === null || locationState === void 0 ? void 0 : locationState.goToHoldingAssetTab)
            assetCategory = (_a = locationState === null || locationState === void 0 ? void 0 : locationState.goToHoldingAssetTab) === null || _a === void 0 ? void 0 : _a.assetCategory;
        //locationState.selectedEle coming from dashboard whn clicked on asset row
        if (assetCategory) {
            let tabDetail = switchTabBasedOnDashboardRowClick(assetCategory);
            // in  tabDetail will get default product  option or all products option  of that assetCategory
            //no need to set Asset type  as it is not used anywhare in holding for Txn
            // on  redirection  tabdetails will return  main Asset
            di.holdingReport.saveProdAssetDropDown(tabDetail.productOption, tabDetail.tabkey);
            let retainedAssets = getRetainedAsset(tabDetail.tabkey);
            di.holdingReport.onAssetChange(retainedAssets.length > 0 ? retainedAssets : [assetCategory], true);
        }
        else {
            //comes when initial render in all tab  with no location state, for refresh as well
            let retainedAssets = getRetainedAsset(activeHoldingTabName);
            if (activeHoldingTabName === FilterTabEnum.ALL) {
                // for all tab only check whether there is retained Asset ,  yes then apply, no then clear all
                di.holdingReport.onAssetChange(retainedAssets);
            }
        }
    }, [locationState]);
    useEffect(() => {
        if (selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode) {
            di.holdingReport.getHoldingReportData({
                familyAccodes: selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode,
            });
        }
        return () => {
            di.holdingReport.getHoldingStreamData(false);
        };
    }, [selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode]);
    useEffect(() => {
        familyDi.familyTagging.setStopFamilyAPICall(true);
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
            di.holdingReport.setHoldingLoader();
        };
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "tabs_pnl tabs-holding" },
            React.createElement("div", { className: "w-100 d-flex justify-content-end" },
                React.createElement("div", { className: "family-tagging-holding", id: "family-tagging-holding" },
                    React.createElement(FamilyTaggingMain, { hideConsolidated: true }))),
            React.createElement(Tabs, { defaultActiveKey: activeHoldingTabName, onSelect: onTabchange, activeKey: activeHoldingTabName, className: `pnl_tabs ${DeviceContext().isMobile && scrollPosition > 100
                    ? "dock_tabs_mobile"
                    : ""}`, style: DeviceContext().isMobile && scrollPosition > 100
                    ? { top: "63px" }
                    : null }, holdingAssetTabs.map((assetTab) => {
                return (React.createElement(Tab, { eventKey: assetTab.eventKey, title: assetTab.title, id: assetTab.id, tabClassName: assetTab.eventKey == FilterTabEnum.INSURANCE &&
                        !isInsuranceVisited
                        ? insuranceTabClass
                        : "" },
                    activeHoldingTabName !== FilterTabEnum.INSURANCE &&
                        !isInsuranceVisited && React.createElement(InsuranceReportBanner, null),
                    HoldingDataFlags.isBodEnabled &&
                        HoldingData.HoldingDetails.length > 0 && (React.createElement(PopBodProcessBlock, { bodProcessInfoMessage: HoldingDataFlags.bodProcessInfoMessage })),
                    holdingLoader ? (React.createElement(ReportsShimmer, null)) : assetTab.eventKey === activeHoldingTabName ? (React.createElement(HoldingReport, { openDrawer: props.openDrawer, setOpenDrawer: props.setOpenDrawer, loader: props.loader, setLoader: props.setLoader, keyTab: assetTab.eventKey, assetFilter: reportsTabAndDropDownData[assetTab.eventKey], setAssetType: props.setAssetType, setDefaultSideBarTab: props.setDefaultSideBarTab, setHoldingStockDetail: props.setHoldingStockDetail, accCode: selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode, isMyaccount: (selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode) === myAccCode })) : (React.createElement(React.Fragment, null))));
            })))));
};
export default React.memo(HoldingReportComponent, (prev, next) => _.isEqual(prev, next));
